<template>
  <div class="mb-6 pt-4" :class="{'b-contract__block_bt': lowValueAssetsIndex > 0}">
    <div class="row col-12 b-form__container_type_flex">
      <div class="px-0 col-11">
        <CreateOrChooseAssetSmallWidget :availableAssetIds="availableAssetIdsForGroupIncludingSelected"
                                        :currentAssetId="assetId"
                                        :isError="validationErrors ? !assetId && validationErrors.assetId : false"
                                        @selectedAssetId="setAssetId"
                                        @createAssetId="onCreateAssetId"/>
      </div>
      <div class="col-1" v-if="lowValueAssetsLength > 1">
        <div class="b-contract__payment-panel-btn">
          <button type="button" class="b-btn b-btn_border_none" @click="deleteAsset">
            <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="delete"></dynamic-icon>
          </button>
        </div>
      </div>
    </div>
    <div v-for="(item, index) in lowValueAssetPeriodSpendings" :key="index">
      <PeriodSpendingsItem
        :periodSpendingsItem="item"
        :periodSpendingsItemIndex="index"
        :periodSpendingsLength="lowValueAssetPeriodSpendings.length"
        :systemCurrencyCode="systemCurrencyCode"
        :validationErrors="validationErrors ? validationErrors.periodSpendings[index] : []"
        @onDeletePeriodSpending="deletePeriodSpendingsItem($event)"
      ></PeriodSpendingsItem>
    </div>
    <div class="row mt-3">
      <div class="col-3">
        <div class="b-form__container">
          <button
            type="button"
            class="b-btn"
            @click="addPeriodSpendings"
            :disabled="isDisabledAddPeriodSpendings"
          >
            <dynamic-icon class="b-btn__icon b-btn__icon_color_main-text" icon="plus"></dynamic-icon>
            {{$t('CONTENT.contract.add_period')}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import {mapGetters} from 'vuex';
  import CreateOrChooseAssetSmallWidget from "../../widgets/CreateOrChooseAssetSmallWidget";
  import PeriodSpendingsItem from "./PeriodSpendingsItem";
  import PeriodSpendings from "../../../models/alternativeContract/PeriodSpendings";

	export default {
		props: {
      systemCurrencyCode: {
			  type: String,
      },
      lowValueAsset: {
        type: Object,
      },
      lowValueAssetsIndex: {
        type: Number,
      },
      availableAssetIdsForGroup: {
        type: Array
      },
      lowValueAssetsLength: {
        type: Number,
      },
      validationErrors: {
        type: Object
      }
    },
		data() {
			return {
        assetId: null
			}
		},
    created() {
      this.assetId = this.lowValueAsset.assetId;
    },
    components: {
      CreateOrChooseAssetSmallWidget,
      PeriodSpendingsItem,
    },
    computed: {
      ...mapGetters(['getAssets']),
      lowValueAssetPeriodSpendings() {
        return this.lowValueAsset.periodSpendings;
      },
      isDisabledAddPeriodSpendings() {
        for (let i = 0; i < this.lowValueAssetPeriodSpendings.length; i++) {
          if (
            this.lowValueAssetPeriodSpendings[i].startDate === null ||
            this.lowValueAssetPeriodSpendings[i].endDate === null ||
            this.lowValueAssetPeriodSpendings[i].sum === null
          ) {
            return true;
          }
        }

        return false;
      },
      availableAssetIdsForGroupIncludingSelected() {
        let availableClone = [...this.availableAssetIdsForGroup];
        if(this.assetId !== null) {
          let choosenAsset = this.getAssets.find(a => a.idInDB === this.assetId);
          availableClone.push(choosenAsset);
        }
        return availableClone;
      },
    },
    watch: {
		  'lowValueAsset.assetId': {
		    handler() {
          this.assetId = this.lowValueAsset.assetId;
        },
        deep: true,
      }
    },
    methods: {
      addPeriodSpendings() {
        this.lowValueAsset.periodSpendings.push(PeriodSpendings.createNew());
      },
      deletePeriodSpendingsItem(itemIndex) {
        this.lowValueAsset.periodSpendings.splice(itemIndex, 1);
      },
      setAssetId(assetIdInfoObject) {
        this.$emit('newAssetSelected', { old: assetIdInfoObject.oldAssetId, new: assetIdInfoObject.currentAssetId});

        if (this.assetId !== assetIdInfoObject.id) {
          this.lowValueAsset.assetId = assetIdInfoObject.currentAssetId;
        }
      },
      onCreateAssetId(assetInfoObj) {
        this.assetId = assetInfoObj.newAssetId;

        this.$emit('newAssetCreated', { old: assetInfoObj.oldAssetId, new: assetInfoObj.newAssetId});
      },
      deleteAsset() {
        this.$emit('deleteAsset', this.assetId);
      },
    }
	}
</script>
